import type {
  ProjectAssignmentResponse,
  ProjectAssignmentRuleCreateRequest,
  ProjectAssignmentRuleExceptionCreateRequest,
  ProjectAssignmentRuleExceptionResponse,
  ProjectAssignmentRuleResponse,
  ProjectAssignmentRuleUpdateRequest,
} from 'src/api/ProactApiClient';
import {projectApiClient} from 'src/api/ProactApiClientInstances';
import {emptySplitApi} from '../api';
import {clientQuery, voidClientQuery} from '../clientQuery';

export const projectAssignmentRuleApi = emptySplitApi.injectEndpoints({
  endpoints: builder => ({
    getProjectAssignmentRulesByProject: builder.query<
      ProjectAssignmentRuleResponse[],
      number
    >({
      queryFn: clientQuery(projectId => projectApiClient.listRules(projectId)),
      providesTags: ['ProjectAssignmentRules'],
    }),
    getProjectAssignmentRule: builder.query<
      ProjectAssignmentRuleResponse,
      number
    >({
      queryFn: clientQuery(id => projectApiClient.getRule(id)),
      providesTags: ['ProjectAssignmentRules'],
    }),
    getProjectAssignments: builder.query<ProjectAssignmentResponse[], number>({
      queryFn: clientQuery(projectId =>
        projectApiClient.listAssignments(projectId)
      ),
      providesTags: ['ProjectAssignments'],
    }),
    createProjectAssignmentRule: builder.mutation<
      ProjectAssignmentRuleResponse,
      ProjectAssignmentRuleCreateRequest
    >({
      queryFn: clientQuery(request => projectApiClient.createRule(request)),
      invalidatesTags: ['ProjectAssignmentRules', 'ProjectRoster'],
    }),
    updateProjectAssignmentRule: builder.mutation<
      ProjectAssignmentRuleResponse,
      ProjectAssignmentRuleUpdateRequest
    >({
      queryFn: clientQuery(request => projectApiClient.updateRule(request)),
      invalidatesTags: ['ProjectAssignmentRules', 'ProjectRoster'],
    }),
    deleteProjectAssignmentRule: builder.mutation<void, number>({
      queryFn: voidClientQuery(id => projectApiClient.deleteRule(id)),
      invalidatesTags: [
        'ProjectAssignmentRules',
        'ProjectAssignmentRuleExceptions',
        'ProjectRoster',
      ],
    }),
    listProjectAssignmentRuleExceptions: builder.query<
      ProjectAssignmentRuleExceptionResponse[],
      number
    >({
      queryFn: clientQuery(ruleId => projectApiClient.listExceptions(ruleId)),
      providesTags: ['ProjectAssignmentRuleExceptions'],
    }),
    addProjectAssignmentRuleException: builder.mutation<
      ProjectAssignmentRuleExceptionResponse,
      ProjectAssignmentRuleExceptionCreateRequest
    >({
      queryFn: clientQuery(request => projectApiClient.addException(request)),
      invalidatesTags: [
        'ProjectAssignmentRuleExceptions',
        'ProjectAssignmentRules',
        'ProjectRoster',
      ],
    }),
    removeProjectAssignmentRuleException: builder.mutation<void, number>({
      queryFn: voidClientQuery(id => projectApiClient.removeException(id)),
      invalidatesTags: [
        'ProjectAssignmentRuleExceptions',
        'ProjectAssignmentRules',
        'ProjectRoster',
      ],
    }),
  }),
});

export const {
  useGetProjectAssignmentRulesByProjectQuery,
  useGetProjectAssignmentRuleQuery,
  useGetProjectAssignmentsQuery,
  useCreateProjectAssignmentRuleMutation,
  useUpdateProjectAssignmentRuleMutation,
  useDeleteProjectAssignmentRuleMutation,
  useListProjectAssignmentRuleExceptionsQuery,
  useAddProjectAssignmentRuleExceptionMutation,
  useRemoveProjectAssignmentRuleExceptionMutation,
} = projectAssignmentRuleApi;
